<template>
  <div class="mt-2 loginForm">
    <form @submit.prevent="formSubmitted">
      <lp-input v-model="email" placeholder="Email" class=""/>
      <lp-input v-model="password" placeholder="Password" type="password" compact />
      <div class="my-1">
        <a v-if="showForgotPassword" @click="onClickForgotPassword" class="blue-link">Forgot your password?</a>
      </div>
      <lp-button :disabled="disableForm || props.isSubmitting" type="primary" class="w-100 mt-1 btn-loading-active" :loading="props.isSubmitting">Sign In</lp-button>
    </form>
  </div>
</template>

<script setup lang="ts">
import { inject, ref, computed, Ref } from 'vue'
import { DEFAULT_CONFIG, useConfig, useConfigSync } from '@/config/useConfig'
import { useAsyncState } from '@vueuse/core'
import { Redirect } from '@/types/redirect'

const redirect = inject('redirect') as Redirect

const showForgotPassword = computed(() => {
  const config = useConfigSync()
  return config?.login_ui_methods?.forgot_password === true || config?.login_ui_methods?.forgot_password === 'true'
})

const onClickForgotPassword = async () => {
  const config = await useConfig()
  redirect('ForgotView')
}

const props = defineProps(['isSubmitting'])
const hideForm: Ref<boolean> = ref(false)
const { state } = useAsyncState(
  useConfig(),
  DEFAULT_CONFIG.value
)
hideForm.value = state.value?.api?.hide_login_form !== undefined ? state.value.api.hide_login_form : false

const emit = defineEmits(['formSubmitted'])

const email: Ref<string> = ref('')
const password: Ref<string> = ref('')

const formSubmitted = () => {
  email.value = email.value.trim()
  emit('formSubmitted', {
    email: email.value,
    password: password.value
  })
}

const disableForm = computed(() => !email.value || !password.value)

</script>

<style>
.lp input[type=password]::placeholder {
  opacity: .3;
  font-size: 1rem;
}

.loginForm .lp-loading .lp-loading-circle {
  stroke: #FFF !important;
}

.service-selector .lp-radio-wrapper .lp-radio-input,
.service-selector .lp-radio-wrapper .lp-radio-border,
.service-selector .lp-radio-wrapper .lp-radio-label-group {
  display: none !important;
  opacity: 0 !important;
}

.blue-link {
  color: #348BFF !important;
}
</style>
